import React, { useContext, useEffect, useState } from "react";
import { CartContextProvider } from "../context/CartContext";
import Navbar from "../components/Navbar";
import CartItem from "../components/Cart/CartItem";
import { Link } from "react-router-dom";
import { fetchApi, sendApi } from "../apis/Index";
import { toast } from "react-hot-toast";
import { RiLoader4Fill } from "react-icons/ri";

const CartPage = () => {
  const { cart, cartError } = useContext(CartContextProvider);
  const [pay, setPay] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCouponLoading, setIsCouponLoading] = useState(false);
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [discount, setDiscount] = useState(0);

  useEffect(() => {
    if (cartError) {
      toast.error(cartError);
    }
  }, [cartError]);

  console.log(cart);

  const validateCoupon = async () => {
    if (!couponCode.trim()) {
      toast("Please enter a coupon code");
      return;
    }

    try {
      setIsCouponLoading(true);
      const result = await sendApi(
        { code: couponCode },
        "https://wittynailtip.com/backend/valid-coupon.php",
      );

      if (result.data && result.data.success) {
        toast.success(`${result.data.discount}% discount applied`);
        setDiscount(Number(result.data.discount) || 0);
        setCouponCode("");
        setShowCouponModal(false);
      } else {
        toast.error(result.data.message || "Invalid coupon code");
        setDiscount(0);
      }
    } catch (error) {
      toast.error("Error validating coupon");
      console.error(error);
    } finally {
      setIsCouponLoading(false);
    }
  };

  const payOrder = async () => {
    const payPend = { pay: "pay" };
    const payApi = "https://wittynailtip.com/backend/pend-order.php";
    try {
      setIsLoading(true);
      const result = await sendApi(payPend, payApi);
      if (result.data.success) {
        setPay(true);
      } else {
        console.log(result.data.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const subtotal =
    cart?.reduce((sum, item) => {
      const unitPrice = item.price?.unit_amount || 0;
      return sum + unitPrice * item.quantity;
    }, 0) || 0;

  // Calculate discount amount
  const discountAmount = (subtotal * discount) / 100;

  const total = (subtotal - discountAmount).toFixed(2);

  useEffect(() => {
    const stripePay = "https://wittynailtip.com/backend/pay-api.php";
    if (pay) {
      async function fetchData() {
        try {
          setIsLoading(true);
          const result = await fetchApi(stripePay);
          if (result.data.success) {
            window.location.href = result.data.url;
          } else {
            console.log(result.data.message);
          }
        } catch (error) {
          console.log(error);
        } finally {
          setIsLoading(false);
        }
      }
      fetchData();
    }
  }, [pay]);

  const emptyCart = async () => {
    const emptyCart = "https://wittynailtip.com/backend/empty-cart.php";
    try {
      const result = await fetchApi(emptyCart);
      if (result.data.success) {
        window.location.reload();
      } else {
        console.log(result.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="font-jost relative bg-gray-50 min-h-screen pb-32">
      {/* <ToastContainer position="bottom-center" autoClose={2000} /> */}
      <Navbar />
      {cart?.length > 0 && (
        <div className="md:w-5/6 w-[90%] mx-auto flex justify-end mt-6">
          <button
            type="button"
            onClick={() => setShowCouponModal(true)}
            className="text-[#FFB7CF] border border-[#FFB7CF] px-6 py-2 rounded-full hover:bg-[#FFB7CF] hover:text-white transition-all font-medium shadow-sm hover:shadow-md"
          >
            Apply Coupon
          </button>
        </div>
      )}
      <div className="md:w-5/6 w-[90%] mx-auto mt-6 md:mt-8 h-full">
        <div className="w-full space-y-4">
          {cart?.length > 0 ? cart.map((e, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-sm p-2 transition-shadow hover:shadow-md">
              <CartItem
                price={e.price?.unit_amount}
                size={e.size}
                cartId={e.cart_id}
                id={e.product_id}
                info={e.description}
                count={e.quantity}
                name={e.name}
                color={e.color}
                image={e.images?.[0] || ""}
              />
            </div>
          )) : (
            <div className="flex flex-col items-center justify-center py-20 px-4 text-center bg-white rounded-3xl shadow-sm mt-10">
              <div className="w-24 h-24 bg-[#fff1f5] rounded-full flex items-center justify-center mb-6">
                <svg className="w-12 h-12 text-[#FFB7CF]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path>
                </svg>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3">Your cart is feeling lonely</h2>
              <p className="text-gray-500 mb-8 max-w-md">Looks like you haven't added any of our fabulous nail sets to your cart yet. Discover your next favorite look!</p>
              <Link to="/">
                <button className="bg-gray-900 hover:bg-black text-white px-8 py-3 rounded-full font-medium transition-all shadow-lg hover:-translate-y-1">
                  Start Shopping
                </button>
              </Link>
            </div>
          )}
        </div>
      </div>

      {cart?.length > 0 && (
        <div
          className="cart-footer flex items-center w-full fixed 
          bottom-0 h-auto min-h-[80px] py-4 bg-white/90 backdrop-blur-md border-t border-gray-100 shadow-[0_-10px_30px_rgba(0,0,0,0.05)] z-40"
        >
          <div className="md:w-5/6 w-[95%] mx-auto flex items-center justify-between z-10">
            <div
              className={`flex text-sm md:text-base font-semibold items-center gap-x-1 `}
            >
              <button
                type="button"
                className="text-red-500 hover:text-red-600 hover:bg-red-50 flex justify-center items-center 
                        rounded-full cursor-pointer px-4 py-2 transition-colors font-medium"
                onClick={() => emptyCart()}
              >
                Empty Cart
              </button>
            </div>

            <div className="flex flex-col items-end mr-4">
              {discount > 0 && (
                <p className="text-xs md:text-sm font-medium text-green-500 bg-green-50 px-2 py-0.5 rounded-full mb-1">
                  {discount}% off (-${subtotal.toFixed(2)})
                </p>
              )}
              <div className="flex items-baseline gap-2">
                <span className="text-gray-500 text-sm">Total:</span>
                <h4 className="text-xl md:text-3xl font-extrabold text-gray-900">${total}</h4>
              </div>
            </div>

            <button
              type="button"
              onClick={() => payOrder()}
              className="text-sm md:text-lg cursor-pointer 
                        flex items-center justify-center text-center
                        text-white tracking-wide font-semibold px-6 md:px-8 py-3 md:py-4 rounded-full bg-[#FFB7CF] hover:bg-[#ff9ebc] shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5"
            >
              {isLoading ? (
                <>
                  Processing...
                  <RiLoader4Fill className="animate-spin ml-2" />
                </>
              ) : (
                `Checkout (${cart?.length})`
              )}
            </button>
          </div>
        </div>
      )}

      {showCouponModal && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-in fade-in duration-200">
          <div className="bg-white p-8 rounded-3xl max-w-md w-full shadow-2xl transform transition-all">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-gray-900">Apply Coupon</h3>
              <button onClick={() => setShowCouponModal(false)} className="text-gray-400 hover:text-gray-600">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
              </button>
            </div>
            
            <p className="text-gray-500 mb-6 text-sm">Enter your promo code below to receive a discount on your fabulous new look.</p>
            
            <input
              type="text"
              value={couponCode}
              onChange={(e) => setCouponCode(e.target.value)}
              placeholder="e.g. SUMMER10"
              className="w-full p-4 border border-gray-200 rounded-xl mb-6 outline-none focus:ring-2 focus:ring-[#FFB7CF] focus:border-transparent transition-all uppercase"
            />

            <button
              type="button"
              onClick={validateCoupon}
              disabled={isCouponLoading || !couponCode.trim()}
              className="w-full py-4 bg-[#FFB7CF] text-white rounded-xl font-bold text-lg disabled:opacity-50 hover:bg-[#ff9ebc] transition-colors shadow-md"
            >
              {isCouponLoading ? (
                <span className="flex items-center justify-center gap-2">
                  <RiLoader4Fill className="animate-spin" /> Validating...
                </span>
              ) : "Apply Discount"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartPage;
